import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    const session_id = m[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        setUser(data.user);
        const dest = data.user.role === "admin" ? "/admin"
          : data.user.role === "seller" ? "/seller" : "/buyer";
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        nav(dest, { replace: true, state: { user: data.user } });
      } catch {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#EDE5D2]">
      <div className="mono text-xs uppercase tracking-[0.3em]">Signing you in…</div>
    </div>
  );
}
